import { render } from "./TaskFolderItemModal.vue?vue&type=template&id=f55f4980"
import script from "./TaskFolderItemModal.vue?vue&type=script&lang=js"
export * from "./TaskFolderItemModal.vue?vue&type=script&lang=js"

import "./TaskFolderItemModal.vue?vue&type=style&index=0&id=f55f4980&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__